export default "__VITE_ASSET__trmDdxOx__"